import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { ListenableEvent } from "../utils";
var AppSettings = /** @class */ (function () {
    function AppSettings() {
        this.eventSnappingChanged = new ListenableEvent(this);
        this.mSnapping = {
            gridEnabled: true,
            gridDynamic: true,
            gridSize: new Vector3(0.1, 0.1, 0.1),
            boundingBoxEnabled: true
        };
    }
    Object.defineProperty(AppSettings.prototype, "snapping", {
        /** Settings for the snapping. Used from tools with snapping support. */
        get: function () {
            return (this.mSnapping);
        },
        enumerable: false,
        configurable: true
    });
    /** Set new snapping settings. Undefined settings will not be changed. */
    AppSettings.prototype.setSnapping = function (pSettings) {
        Object.assign(this.mSnapping, pSettings);
        this.eventSnappingChanged.trigger();
    };
    return AppSettings;
}());
export { AppSettings };
